/**
 * billingRI模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const billingRI = {
  // 查询当前预留实例列表
  listCurrentReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/billingRI/listCurrentReservedInstance`,params);
  },
  //查询DH Host 预留实例列表
  listDHHostReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/billingRI/listDHHostReservedInstance`,params);
  },
  //查询开发环境预留实例列表
  listDevEnvironmentReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/billingRI/listDevEnvironmentReservedInstance`,params);
  },
  //查询当前RDS、ElastiCache、Redshift、ElastiSearch等服务预留实例列表
  listNotEc2ReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/billingRI/listNotEc2ReservedInstance`,params);
  },
  //查询生产环境预留实例列表
  listProdEnvironmentReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/billingRI/listProdEnvironmentReservedInstance`,params);
  },
  //查询推荐预留实例列表
  listRecommendedReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/billingRI/listRecommendedReservedInstance`,params);
  },
  //导出
  exportBilling(params) {
    return $http.post(`${global.API_URL}/sme/billingRI/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  }
}

export default billingRI;


// WEBPACK FOOTER //
// ./src/api/billingRI.js